"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacetsStruct = exports.DomainFacetStruct = exports.AliasFacetStruct = exports.PageFacetStruct = exports.ExperimentFacetStruct = exports.SearchFacetStruct = exports.UserFacetStruct = exports.UserInfoStruct = exports.OperationFacetStruct = exports.EntitlementFacetStruct = exports.ContentFacetStruct = exports.ComponentFacetStruct = exports.ProductFacetStruct = exports.ProductMetaStruct = exports.ProductReferrerStruct = exports.BrowserFacetStruct = exports.DeviceFacetStruct = exports.HttpFacetStruct = void 0;
const superstruct_1 = require("superstruct");
/** @internal */
exports.HttpFacetStruct = (0, superstruct_1.assign)((0, superstruct_1.object)({
    method: (0, superstruct_1.string)(),
    remoteip: (0, superstruct_1.string)(),
    request_headers: (0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.string)()),
    request_len: (0, superstruct_1.number)(),
    response_code: (0, superstruct_1.string)(),
    response_headers: (0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.string)()),
    url: (0, superstruct_1.string)(),
}), (0, superstruct_1.partial)({
    form_params: (0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.string)()),
}));
/** @internal */
exports.DeviceFacetStruct = (0, superstruct_1.partial)({
    carrier: (0, superstruct_1.string)(),
    desc: (0, superstruct_1.string)(),
    hw_concurrency: (0, superstruct_1.number)(),
    hw_display: (0, superstruct_1.string)(),
    hw_form: (0, superstruct_1.string)(),
    hw_input: (0, superstruct_1.array)((0, superstruct_1.string)()),
    hw_locale: (0, superstruct_1.string)(),
    hw_model: (0, superstruct_1.string)(),
    hw_proc: (0, superstruct_1.string)(),
    hw_ram: (0, superstruct_1.string)(),
    hw_storage: (0, superstruct_1.string)(),
    hw_vendor: (0, superstruct_1.string)(),
    hw_video: (0, superstruct_1.string)(),
    name: (0, superstruct_1.string)(),
    os_locale: (0, superstruct_1.string)(),
    os_name: (0, superstruct_1.string)(),
    os_type: (0, superstruct_1.string)(),
    os_vendor: (0, superstruct_1.string)(),
    os_version: (0, superstruct_1.string)(),
    meta: (0, superstruct_1.object)({
        device_id_v1: (0, superstruct_1.string)(),
        device_id_v2: (0, superstruct_1.string)(),
    }),
});
/** @internal */
exports.BrowserFacetStruct = (0, superstruct_1.partial)({
    cookie_enabled: (0, superstruct_1.boolean)(),
    language: (0, superstruct_1.array)((0, superstruct_1.string)()),
    online: (0, superstruct_1.boolean)(),
    platform: (0, superstruct_1.string)(),
    type: (0, superstruct_1.string)(),
    user_agent: (0, superstruct_1.string)(),
    timezone: (0, superstruct_1.string)(),
});
/** @internal */
exports.ProductReferrerStruct = (0, superstruct_1.type)({
    REFERRER_ID: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    REFERRER_NAME: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    REFERRER_VERSION: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    REFERRER_SESSION: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    REFERRER_TYPE: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
/** @internal */
exports.ProductMetaStruct = (0, superstruct_1.intersection)([exports.ProductReferrerStruct, (0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.string)())]);
/** @internal */
exports.ProductFacetStruct = (0, superstruct_1.assign)((0, superstruct_1.object)({
    id: (0, superstruct_1.string)(),
    id_provider: (0, superstruct_1.enums)(["appkey", "cls", "o2", "upi1", "upi2"]),
    name: (0, superstruct_1.string)(),
}), (0, superstruct_1.partial)({
    build_id: (0, superstruct_1.string)(),
    build_tag: (0, superstruct_1.string)(),
    components: (0, superstruct_1.array)((0, superstruct_1.object)({
        id: (0, superstruct_1.string)(),
        name: (0, superstruct_1.string)(),
        version: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    })),
    install_adjacency: (0, superstruct_1.array)((0, superstruct_1.object)({
        product_build_id: (0, superstruct_1.optional)((0, superstruct_1.string)()),
        product_line_name: (0, superstruct_1.string)(),
        product_release_id: (0, superstruct_1.string)(),
    })),
    key: (0, superstruct_1.string)(),
    line_name: (0, superstruct_1.string)(),
    locale: (0, superstruct_1.string)(),
    master_id: (0, superstruct_1.string)(),
    platform: (0, superstruct_1.string)(),
    release_id: (0, superstruct_1.string)(),
    suite_name: (0, superstruct_1.string)(),
    meta: exports.ProductMetaStruct,
}));
/** @internal */
exports.ComponentFacetStruct = (0, superstruct_1.partial)({
    attributes: (0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.string)()),
    id: (0, superstruct_1.string)(),
    metrics: (0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.string)()),
    name: (0, superstruct_1.string)(),
    type: (0, superstruct_1.string)(),
});
/** @internal */
exports.ContentFacetStruct = (0, superstruct_1.assign)((0, superstruct_1.object)({
    id: (0, superstruct_1.string)(),
    type: (0, superstruct_1.string)(),
}), (0, superstruct_1.partial)({
    country: (0, superstruct_1.string)(),
    create_time: (0, superstruct_1.string)(),
    hash: (0, superstruct_1.string)(),
    locale: (0, superstruct_1.string)(),
    meta: (0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.unknown)()),
    name: (0, superstruct_1.string)(),
    parent: (0, superstruct_1.string)(),
    parts: (0, superstruct_1.number)(),
    publish_time: (0, superstruct_1.string)(),
    root: (0, superstruct_1.string)(),
    size: (0, superstruct_1.number)(),
    translation: (0, superstruct_1.enums)(["M", "T", "U"]),
}));
/** @internal */
exports.EntitlementFacetStruct = (0, superstruct_1.assign)((0, superstruct_1.object)({
    license_id: (0, superstruct_1.string)(),
}), (0, superstruct_1.partial)({
    account_id: (0, superstruct_1.string)(),
    contract_id: (0, superstruct_1.string)(),
    deployment: (0, superstruct_1.string)(),
    end: (0, superstruct_1.string)(),
    features: (0, superstruct_1.array)((0, superstruct_1.object)({
        id: (0, superstruct_1.string)(),
        name: (0, superstruct_1.string)(),
        type: (0, superstruct_1.string)(),
    })),
    license_model: (0, superstruct_1.string)(),
    model: (0, superstruct_1.string)(),
    offering_family_id: (0, superstruct_1.string)(),
    offering_id: (0, superstruct_1.string)(),
    order_id: (0, superstruct_1.string)(),
    properties: (0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.string)()),
    quantity: (0, superstruct_1.number)(),
    source: (0, superstruct_1.string)(),
    start: (0, superstruct_1.string)(),
    status: (0, superstruct_1.string)(),
    usage: (0, superstruct_1.string)(),
    validity: (0, superstruct_1.string)(),
}));
/** @internal */
exports.OperationFacetStruct = (0, superstruct_1.assign)((0, superstruct_1.object)({
    id: (0, superstruct_1.string)(),
    stage: (0, superstruct_1.string)(),
    status: (0, superstruct_1.enums)(["A", "C", "D", "E", "F", "I", "R", "S"]),
    type: (0, superstruct_1.string)(),
}), (0, superstruct_1.partial)({
    channel: (0, superstruct_1.string)(),
    duration: (0, superstruct_1.number)(),
    errors: (0, superstruct_1.array)((0, superstruct_1.string)()),
    meta: (0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.string)()),
    progress: (0, superstruct_1.number)(),
    success: (0, superstruct_1.number)(),
}));
/** @internal */
exports.UserInfoStruct = (0, superstruct_1.assign)((0, superstruct_1.object)({
    provider_name: (0, superstruct_1.string)(),
    user_id: (0, superstruct_1.string)(),
}), (0, superstruct_1.partial)({
    ldap_registration: (0, superstruct_1.string)(),
    ldap_root: (0, superstruct_1.string)(),
    logged_in: (0, superstruct_1.boolean)(),
    roles: (0, superstruct_1.array)((0, superstruct_1.string)()),
}));
/** @internal */
exports.UserFacetStruct = (0, superstruct_1.assign)((0, superstruct_1.object)({
    info: (0, superstruct_1.array)(exports.UserInfoStruct),
}), (0, superstruct_1.partial)({
    project_id: (0, superstruct_1.string)(),
    project_urn: (0, superstruct_1.string)(),
    hub_id: (0, superstruct_1.string)(),
    hub_urn: (0, superstruct_1.string)(),
    consent_metric: (0, superstruct_1.array)((0, superstruct_1.object)({
        consentId: (0, superstruct_1.string)(),
        optIn: (0, superstruct_1.boolean)(),
    })),
    intent: (0, superstruct_1.string)(),
}));
/** @internal */
exports.SearchFacetStruct = (0, superstruct_1.assign)((0, superstruct_1.object)({
    keywords: (0, superstruct_1.string)(),
}), (0, superstruct_1.partial)({
    locale: (0, superstruct_1.string)(),
    result_count: (0, superstruct_1.number)(),
}));
/** @internal */
exports.ExperimentFacetStruct = (0, superstruct_1.assign)((0, superstruct_1.object)({
    collection_id: (0, superstruct_1.array)((0, superstruct_1.string)()),
    dashboard_id: (0, superstruct_1.array)((0, superstruct_1.string)()),
}), (0, superstruct_1.partial)({
    info: (0, superstruct_1.string)(),
}));
/** @internal */
exports.PageFacetStruct = (0, superstruct_1.partial)({
    category: (0, superstruct_1.string)(),
    keywords: (0, superstruct_1.array)((0, superstruct_1.string)()),
    name: (0, superstruct_1.string)(),
    path: (0, superstruct_1.string)(),
    properties: (0, superstruct_1.intersection)([
        (0, superstruct_1.partial)((0, superstruct_1.type)({
            page_urlhost: (0, superstruct_1.string)(),
            page_url_params: (0, superstruct_1.string)(),
            page_urlpath: (0, superstruct_1.string)(),
            page_urlport: (0, superstruct_1.string)(),
            page_urlscheme: (0, superstruct_1.string)(),
            page_referrer_urlhost: (0, superstruct_1.string)(),
            page_referrer_urlpath: (0, superstruct_1.string)(),
            page_referrer_urlport: (0, superstruct_1.string)(),
            page_referrer_urlscheme: (0, superstruct_1.string)(),
        })),
        (0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.string)()),
    ]),
    referrer: (0, superstruct_1.string)(),
    search: (0, superstruct_1.string)(),
    title: (0, superstruct_1.string)(),
    url: (0, superstruct_1.string)(),
    utm_source: (0, superstruct_1.string)(),
    utm_medium: (0, superstruct_1.string)(),
    utm_campaign: (0, superstruct_1.string)(),
    utm_content: (0, superstruct_1.string)(),
    utm_term: (0, superstruct_1.string)(),
});
/** @internal */
exports.AliasFacetStruct = (0, superstruct_1.object)({
    previous_id: (0, superstruct_1.string)(),
    new_id: (0, superstruct_1.string)(),
});
/** @internal */
exports.DomainFacetStruct = (0, superstruct_1.object)({
    name: (0, superstruct_1.nonempty)((0, superstruct_1.string)()),
    event_info: (0, superstruct_1.refine)((0, superstruct_1.type)({}), "Non-empty Object", (value) => Object.keys(value).length > 0),
    schema_name: (0, superstruct_1.nonempty)((0, superstruct_1.string)()),
    schema_version: (0, superstruct_1.nonempty)((0, superstruct_1.string)()),
});
/** @internal */
exports.FacetsStruct = (0, superstruct_1.partial)({
    any: (0, superstruct_1.object)({}),
    browser: exports.BrowserFacetStruct,
    component: exports.ComponentFacetStruct,
    content: exports.ContentFacetStruct,
    device: exports.DeviceFacetStruct,
    entitlement: exports.EntitlementFacetStruct,
    experiment: exports.ExperimentFacetStruct,
    http: exports.HttpFacetStruct,
    operation: exports.OperationFacetStruct,
    page: exports.PageFacetStruct,
    product: exports.ProductFacetStruct,
    search: exports.SearchFacetStruct,
    user: exports.UserFacetStruct,
    alias: exports.AliasFacetStruct,
    domain: exports.DomainFacetStruct,
});
